#@import GliveBooking.Presenters.Price
#@export GliveBooking.Views.Price

class GliveBooking.Views.Price extends BookingV2.Views.Base

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Price

  templateName: 'price'

  tagName: 'li'

  events:
    'click': 'select'

  select: ->
    @trigger('select', @model)
